import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { TextAreaInput } from "../../Helpers/Input/Input";
import trans from "../../../utils";
import Button from "../../Helpers/Button/Button";
import { popupcontext } from "../../../context/Popupscontext";
import { toast } from "react-toastify";
import Loader from "../../Helpers/Loader/Loader";
import { useSelector } from "react-redux";
import {
	useConsultantQASubmittalMutation,
	useQaSubmittalMutation,
} from "../../../Redux/service/Submittals/Submittals";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../Helpers/CloseBtn/Close";
import { Modal } from "react-bootstrap";
import Dropfile from "../../Helpers/Dropzone/Dropzone";

export default function SubmittalsReview({ refetch, resubmit, setResubmit }) {
	const initialValues = {
		action: null,
		comments: null,
		attachments: [], // reviewers may attach marked-up documents
	};
	const [action, setAction] = useState(null);
	const [AddCQA, { isLoading }] = useConsultantQASubmittalMutation();
	const [AddQA, { isLoading: QaLoading }] = useQaSubmittalMutation();

	let { currentSubmittalId, setcurrentSubmittalId, setReloadData } =
		useContext(popupcontext);
	const inf = useSelector((state) => state.users.user);

	let addQA = useFormik({
		initialValues,
		onSubmit: async (val) => {
			try {
				val.action = action;
				if (inf.attributes.role === "qa") {
					if (
						val.action === "return" &&
						(val.comments === "" || val.comments === null)
					) {
						toast.error(
							trans("Please add comment in case of Returning Submittal"),
							{
								autoClose: 800,
								rtl: localStorage.getItem("lang") === "ar" ? true : false,
							}
						);
					} else {
						await AddQA({ id: currentSubmittalId, val }).unwrap();
						toast.success(trans("Submittal QA Review Submitted Successfully"), {
							autoClose: 800,
							rtl: localStorage.getItem("lang") === "ar" ? true : false,
						});
						refetch();
						setcurrentSubmittalId(null);
						setReloadData(true);
					}
				} else if (inf.attributes.role === "consultant") {
					if (
						(val.action === "revision" || val.action === "reject") &&
						(val.comments === "" || val.comments === null)
					) {
						toast.error(
							trans(
								`Please add comment in case of ${
									action === "revision" ? "Revisioning" : "Rejecting"
								} Submittal`
							),
							{
								autoClose: 800,
								rtl: localStorage.getItem("lang") === "ar" ? true : false,
							}
						);
					} else {
						await AddCQA({ id: currentSubmittalId, val }).unwrap();
						toast.success(
							trans("Submittal Consultant Review Submitted Successfully"),
							{
								autoClose: 800,
								rtl: localStorage.getItem("lang") === "ar" ? true : false,
							}
						);
						refetch();
						setcurrentSubmittalId(null);
						setReloadData(true);
					}
				}
			} catch (error) {
				console.log("errr", error);
				toast.error(`${error?.data?.message}`, {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});

	return (
		<Popup show={resubmit}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle
						headtitle={
							inf.attributes.role === "qa"
								? trans("QA Review")
								: trans("Consultant Review")
						}
					/>
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={() => setResubmit(false)}
					img="Close"
				/>
			</Modal.Header>
			<Modal.Body className="modal-body-scrollable">
				{QaLoading || isLoading ? (
					<div className="loader-container">
						<Loader />
					</div>
				) : (
					<form onSubmit={addQA.handleSubmit}>
						<TextAreaInput
							title={trans("Comments")}
							rows={3}
							placeholder={trans("Enter your comments")}
							id="comments"
							name="comments"
							onChange={(e) => addQA.handleChange(e)}
							onBlur={(e) => addQA.handleBlur(e)}
						/>
						<div className="mt-3">
							<Dropfile
								addData={addQA}
								name="attachments"
								totalfiles={10}
								totalsize={50}
								maxtotalsize={50 * 1024 * 1024}
							/>
						</div>
						<div className="d-flex align-items-center mt-2">
							<Button
								htmlType="submit"
								type="primary"
								text={trans("Approve")}
								onClick={() => setAction("approve")}
								className="me-2"
							/>
							{inf.attributes.role === "qa" && (
								<Button
									htmlType="submit"
									danger={true}
									text={trans("Return")}
									type="default"
									onClick={() => setAction("return")}
								/>
							)}
							{inf.attributes.role === "consultant" && (
								<>
									<Button
										htmlType="submit"
										danger={true}
										text={trans("Revision")}
										type="default"
										onClick={() => setAction("revision")}
										className="mx-2"
									/>
									<Button
										htmlType="submit"
										danger={true}
										text={trans("Reject")}
										type="default"
										onClick={() => setAction("reject")}
									/>
								</>
							)}
						</div>
					</form>
				)}
			</Modal.Body>
		</Popup>
	);
}
